import React, { useEffect } from 'react';

import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { required, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { AutocompleteInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

import { JsonInputStyled } from './MerchantsShowCredentialsForm.styled';
import { MerchantsShowCredentialsFormSkeleton } from './MerchantsShowCredentialsFormSkeleton';
import { MerchantsShowCredentialsNameInput } from './MerchantsShowCredentialsNameInput';

type Props = {
  errors?: string[];
  merchantName?: string;
};

export const MerchantsShowCredentialsForm: React.FC<Props> = ({ errors, merchantName }) => {
  const { setError } = useFormContext();

  const record = useRecordContext();
  const { ready } = useNormalizeReferences({
    referenceFields: ['provider'],
    externalRecord: record,
  });

  useEffect(() => {
    errors?.forEach((error: string) => {
      const [field, message] = error.split(':');
      setError(field, { type: 'custom', message });
    });
  }, [errors]);

  if (!ready) {
    return (
      <Box>
        <MerchantsShowCredentialsFormSkeleton />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
      <Box sx={{ width: '396px' }}>
        <MerchantsShowCredentialsNameInput
          fullWidth={true}
          key="name"
          label="Название"
          merchantName={merchantName}
          size="small"
          source="name"
          validate={required()}
          variant="outlined"
        />
        <ReferenceInput perPage={200} reference="providers" source="provider">
          <AutocompleteInput
            filterToQuery={(searchText: string) => ({ name: searchText })}
            fullWidth
            label="Провайдер"
            optionText="name"
            size="small"
            source="provider"
            sx={{ marginTop: '0px' }}
            validate={required()}
            variant="outlined"
          />
        </ReferenceInput>
        <TextInput
          fullWidth={true}
          helperText={false}
          key="comment"
          label="Комментарий"
          multiline
          resettable
          size="small"
          source="comment"
          sx={{ textarea: { height: '103px !important', overflowY: 'auto !important' } }}
          variant="outlined"
        />
      </Box>
      <Box sx={{ width: '814px', display: 'flex' }}>
        <JsonInputStyled label="Редактор реквизитов доступа {json}" source="credentials" />
      </Box>
    </Box>
  );
};
